import { useCompanyStylesCtx } from '@contexts/CompanyStylesContext/CompanyStylesProvider';
import * as React from 'react';
import { isDefined } from '~logic/helpers/isDefined';
import { Box } from '~ui/components/layout/Box';
import { Image } from '~ui/components/media/Image/Image';
import { jsx as _jsx } from "react/jsx-runtime";
var DEFAULT_SIZE = "7.5rem";
/**
 * A component that renders the company logo.
 */

export var LogoBox = function LogoBox(_ref) {
  var logoSize = _ref.logoSize;

  var _useCompanyStylesCtx = useCompanyStylesCtx(),
      images = _useCompanyStylesCtx.images,
      primaryNameLabel = _useCompanyStylesCtx.primaryNameLabel;

  var logoUrl = images.companyLogoUrl;

  if (!isDefined(logoUrl)) {
    return null;
  }

  var size = logoSize || DEFAULT_SIZE; // TODO - use next image/skeleton?

  return /*#__PURE__*/_jsx(Box, {
    height: size,
    width: size,
    overflow: "hidden",
    radius: "medium",
    children: /*#__PURE__*/_jsx(Image, {
      src: logoUrl,
      alt: "".concat(primaryNameLabel, " logo"),
      objectFit: "cover",
      maxHeight: size,
      maxWidth: size
    })
  });
};